<template>
  <div class="steps-content">
    <el-form
      ref="form"
      :model="formData"
      :rules="thirdStepRules"
      @submit.native.prevent
    >
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <el-form-item prop="freight_id">
            <p>Тип груза</p>
            <el-select
              v-model.number="formData.freight_id"
              placeholder="Выберите"
            >
              <el-option
                v-for="item in cultures"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item v-if="!isTudatka" prop="weight">
            <p>Объём перевозки, т</p>
            <el-input-number
              v-model="formData.weight"
              controls-position="right"
              :min="0"
              placeholder="Укажите объем перевозки"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col v-if="!edit" :xs="24" :sm="12" class="st_price">
          <template v-if="!isTudatka">
            <template v-if="saved.type_code !== 'harvest'">
              <el-form-item prop="price_from_storage_bidder">
                <p>Цена перевозки, руб/кг</p>
                <el-input-number
                  v-model="formData.price_from_storage_bidder"
                  :controls="false"
                  :min="0"
                  :step="0.02"
                  :max="500000"
                  :precision="3"
                  placeholder="Укажите цену перевозки"
                />
              </el-form-item>
              <el-form-item
                v-if="isAdminOrCeoRole"
                prop="price_from_storage_driver"
              >
                <p>Цена перевозки для водителя, руб/кг</p>
                <el-input-number
                  v-model="formData.price_from_storage_driver"
                  :controls="false"
                  :min="0"
                  :step="0.02"
                  :max="500000"
                  :precision="3"
                  placeholder="Укажите цену перевозки для водителя"
                />
              </el-form-item>
            </template>
            <template v-if="saved.type_code !== 'delivery'">
              <el-form-item prop="price_from_field_bidder">
                <p>Цена уборки, руб/кг</p>
                <el-input-number
                  v-model="formData.price_from_field_bidder"
                  :controls="false"
                  :min="0"
                  :step="0.02"
                  :max="500000"
                  :precision="3"
                  placeholder="Укажите цену уборки"
                />
              </el-form-item>
              <el-form-item
                v-if="isAdminOrCeoRole"
                prop="price_from_field_driver"
              >
                <p>Цена уборки для водителя, руб/кг</p>
                <el-input-number
                  v-model="formData.price_from_field_driver"
                  :controls="false"
                  :min="0"
                  :step="0.02"
                  :max="500000"
                  :precision="3"
                  placeholder="Укажите цену уборки для водителя"
                />
              </el-form-item>
            </template>
          </template>
          <template v-else>
            <el-form-item prop="price_from_storage_bidder">
              <p>Цена за рейс, руб</p>
              <el-input-number
                v-model="formData.price_from_storage_bidder"
                :controls="false"
                :min="0"
                :step="0.02"
                :max="500000"
                :precision="3"
                placeholder="Укажите цену за рейс"
                @change="setTudatkaPrices"
              />
            </el-form-item>
          </template>
        </el-col>
        <el-col :xs="24" :sm="12">
          <template v-if="!isTudatka">
            <el-form-item prop="allow_shortage">
              <p>
                <span class="mr25">Допустимая недостача</span>
                <el-radio-group v-model="formData.allow_shortage_is_percents">
                  <el-radio :label="1">%</el-radio>
                  <el-radio :label="0">кг</el-radio>
                </el-radio-group>
              </p>
              <el-input-number
                v-model="formData.allow_shortage"
                controls-position="right"
                :precision="2"
                :min="0"
                placeholder="Укажите допустимую недостачу"
              />
            </el-form-item>
            <div class="fast_select">
              <span>Быстрый выбор:</span>
              <span v-for="item in fast_link_data.percent" :key="item">
                <a
                  href
                  class="c-quick-pick__link c-link"
                  @click.prevent="clickItem(item, 'allow_shortage', 1)"
                >
                  {{ item }}
                </a>
              </span>
            </div>
          </template>
        </el-col>
        <el-col :xs="24" :sm="12">
          <template v-if="!isTudatka">
            <p>Цена товара, руб/тонн</p>
            <el-input-number
              v-model="formData.freight_price_per_kg"
              controls-position="right"
              :precision="0"
              :min="0"
              placeholder="Укажите вознаграждение"
            />
          </template>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :xs="24" :sm="12">
          <p>Комментарий</p>
          <el-input
            v-model="formData.comment"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Ваш комментарий"
          />
        </el-col>
        <el-col :xs="24" :sm="12">
          <p>Телефон ответственного</p>
          <el-input
            v-model="formData.private_comment"
            placeholder="Телефон ответственного"
          />
        </el-col>
        <el-col :xs="24" :sm="12">
          <loader-wrapper
            :loading="loading"
            background="rgba(249,249,249,.9)"
            custom-class="manager-loader"
          >
            <p v-if="ownManagers.length || isNotMyManager">
              {{ isNotMyManager ? 'Менеджер' : 'Выбор менеджера' }}
            </p>
            <p v-if="isNotMyManager">
              {{ isNotMyManager }}
            </p>
            <el-select
              v-if="ownManagers.length && !isNotMyManager"
              v-model="formData.managers"
              placeholder="Выберите"
              clearable
              @clear="clearManager"
            >
              <el-option
                v-for="m in ownManagers"
                :key="m.id"
                :label="m.profile.fio"
                :value="m.id"
              />
            </el-select>
          </loader-wrapper>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-divider v-if="!edit" content-position="left">
          Поручение на перевозку
        </el-divider>
        <el-col :xs="24" :sm="12" style="min-height: 1px">
          <el-form-item v-if="!edit" prop="carrier_request_number">
            <p>Поручение №:</p>
            <el-input
              v-model="formData.carrier_request_number"
              placeholder="Введите № поручения"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12">
          <el-switch
            v-model="formData.require_payment"
            active-color="#409eff"
            inactive-color="#cccccc"
            active-text="Внутренняя перевозка"
            :active-value="1"
            :inactive-value="0"
            style="margin-top: 27px"
          />
        </el-col>
      </el-row>
    </el-form>
    <div class="bottom_buttons">
      <el-button @click="setFormData(-1)">Назад</el-button>
      <el-button type="primary" class="post_bids" @click="reqShipping">
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
import { fast_link_data, pickerOpt } from '@/datas/consts'
import { mapGetters } from 'vuex'
import { thirdStepRules, tudatkaParamsFormThree } from './constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'Three',
  components: { LoaderWrapper },
  props: {
    saved: {
      type: Object,
      default: () => undefined,
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      formData: {
        freight_id: '',
        weight: undefined,
        allow_shortage: undefined,
        allow_shortage_is_percents: 1,
        price_from_storage_bidder: undefined,
        price_from_storage_driver: undefined,
        price_from_field_bidder: undefined,
        price_from_field_driver: undefined,
        freight_price_per_kg: undefined,
        comment: '',
        private_comment: '',
        managers: undefined,
        carrier_request_number: '',
        require_payment: 0,
      },
      isNotMyManager: '',
      pickerOpt,
      fast_link_data,
      thirdStepRules,
      tudatkaDefault: tudatkaParamsFormThree,
    }
  },
  computed: {
    ...mapGetters({
      getLib: 'libs/getLib',
      ownManagers: 'managers/getManagers',
      loading: 'managers/getLoading',
    }),
    cultures() {
      return this.getLib('freightTypes')
    },
    isTudatka() {
      return this.saved.is_tudatka
    },
  },
  watch: {
    saved: {
      immediate: true,
      handler(newVal) {
        /** логика при разном типе менеджеров**/
        const isNotNum = typeof newVal['managers'] !== 'number'
        let managers

        if (newVal['managers'] && isNotNum && newVal['managers'].length) {
          managers = newVal['managers'][0].id
        }
        if (!isNotNum && newVal['managers']) {
          managers = newVal['managers']
        }

        this.isNotMyManager =
          managers &&
          (!this.ownManagers.length ||
            !this.ownManagers.filter(m => m.id === managers).length)
            ? newVal['managers'][0].fio
            : ''
        this.formData = { ...newVal, managers }

        // для тудатки заполняем скрытые поля дефолтами
        if (this.isTudatka) {
          for (let key in this.tudatkaDefault) {
            this.formData[key] = this.tudatkaDefault[key]
          }
        }
      },
    },
  },
  methods: {
    clearManager() {
      this.formData.managers = null
    },
    clickItem(item, param, num = false) {
      this.formData.allow_shortage_is_percents = item.includes('%') ? 1 : 0

      if (num) {
        item = parseFloat(item)
      }
      this.formData[param] = item
    },
    setTudatkaPrices() {
      this.formData.price_from_storage_driver =
        this.formData.price_from_storage_bidder
    },
    setFormData(step) {
      const data = { ...this.formData }

      delete data.managers
      this.$emit('change_step', { data, step })
    },
    reqShipping() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.ownManagers.length && !this.formData.managers) {
            this.$confirm('Вы не выбрали менеджера для погрузки', 'Внимание!', {
              confirmButtonText: 'Все равно сохранить',
              cancelButtonText: 'Назад',
              type: 'warning',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
            })
              .then(() => this.$emit('req_shipping', this.formData))
              .catch(() => {})
          } else {
            this.$emit('req_shipping', this.formData)
          }
        } else {
          this.$emit('invalid')
        }
      })
    },
  },
}
</script>
